import React from "react";

import toLower from "lodash/toLower";

import DatePickerController from "../forms/DatePickerController";
import RadioGroupController from "../forms/RadioGroupController";
import {
  digitalAdvertisingOptions1,
  digitalAdvertisingOptions2,
  digitalAdvertisingOptions3,
  yesNoOptions,
} from "../../helpers/constants";
import CheckboxItemGroupController from "../forms/CheckboxItemGroupController";
import { FormControlLabel } from "@mui/material";
import TextFieldController from "../forms/TextFieldController";

const CheckBoxItem = ({ control, option }) => (
  <FormControlLabel
    key={`digital-advertising-${option}`}
    control={
      <CheckboxItemGroupController
        name="advertise.digitalAdvertising"
        control={control}
        item={{ id: toLower(option) }}
      />
    }
    label={option}
    slotProps={{
      typography: {
        sx: {
          fontSize: 12,
          color: "var(--light-grey-text)",
          fontWeight: 700,
          textTransform: "capitalize",
        },
      },
    }}
  />
);

const AdvertiseForm = ({ control }) => {
  return (
    <>
      <div className="row">
        <label className="form-group-label text-red">
          Panneau<span>*</span>
        </label>
        <RadioGroupController
          control={control}
          name="advertise.panel"
          options={yesNoOptions}
          row
        />
      </div>
      <div className="row">
        <label className="form-group-label text-red">
          Event<span>*</span>
        </label>
        <DatePickerController
          control={control}
          name="advertise.event"
          className="required"
        />
      </div>
      <div className="row">
        <label className="form-group-label text-red">
          Publicité papier<span>*</span>
        </label>
        <RadioGroupController
          control={control}
          name="advertise.printAdvertising"
          options={yesNoOptions}
          row
        />
      </div>
      <div className="row">
        <label className="form-group-label text-red">
          Publicité digitale<span>*</span>
        </label>
        <div className="col-md-4 col-sm-12 d-flex flex-column">
          {digitalAdvertisingOptions1.map((option) => (
            <CheckBoxItem control={control} option={option.name} />
          ))}
        </div>
        <div className="col-md-4 col-sm-12 d-flex flex-column">
          {digitalAdvertisingOptions2.map((option) => (
            <CheckBoxItem control={control} option={option.name} />
          ))}
        </div>
        <div className="col-md-4 col-sm-12 d-flex flex-column">
          {digitalAdvertisingOptions3.map((option) => (
            <CheckBoxItem control={control} option={option.name} />
          ))}
        </div>
      </div>
      <div className="row">
        <div className="col-md-6 col-sm-12">
          <label className="form-group-label">
            Mailings projet<span>*</span>
          </label>
          <TextFieldController
            control={control}
            name="advertise.mailingsProject"
            type="number"
            defaultValue={0}
            disabled
          />
        </div>
        <div className="col-md-6 col-sm-12">
          <label className="form-group-label">
            Mailings sur unité<span>*</span>
          </label>
          <TextFieldController
            control={control}
            name="advertise.mailingsUnits"
            type="number"
            defaultValue={0}
            disabled
          />
        </div>
      </div>
    </>
  );
};

export default AdvertiseForm;
